import { feedbacks } from "@/mocks/gossip";
import SectionHeading from "./SectionHeading";

const colors = ["bg-primary-100 text-primary-700", "bg-accent-100 text-accent-700", "bg-secondary-100 text-secondary-800"];

export default function WordWall() {
  return (
    <section id="word" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-6xl px-4 md:px-6 lg:px-8">
        <SectionHeading
          eyebrow="围观群众怎么说"
          title="来自吃瓜现场的真实反馈"
          desc="感谢每一位一起蹲后续、催更、求指路的你。你在现场的声音，就是我们持续更新的动力。"
        />

        <div className="mt-12 grid grid-cols-1 gap-5 md:grid-cols-3">
          {feedbacks.map((f, i) => (
            <figure
              key={f.name}
              className="flex flex-col rounded-2xl border border-background-200 bg-background-50 p-6"
            >
              <div className="flex items-center gap-1 text-accent-500" aria-label="好评">
                {Array.from({ length: 5 }).map((_, n) => (
                  <i key={n} className="ri-star-fill text-sm"></i>
                ))}
              </div>
              <blockquote className="mt-4 flex-1 text-sm leading-7 text-foreground-700">
                “{f.text}”
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200/70 pt-4">
                <span
                  className={`flex h-10 w-10 items-center justify-center rounded-full font-heading text-base font-bold ${colors[i]}`}
                >
                  {f.name.charAt(0)}
                </span>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{f.name}</div>
                  <div className="text-xs text-foreground-500">{f.tag}</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}